import React, { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import logo from '../../assets/LogoWhite.png'
import avatar from '../../assets/user.jpg'
import './navbar.scss'
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../store/thunk/actionThunk';
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import Notifications from '../notifications/notifications';
import MenuIcon from '@mui/icons-material/Menu';
import SideNav from '../adminDashboard/sideNav/sideNav';

function Navbar() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const userDetails = useAppSelector((state: any) => state.user.user)
    const logOut = async () => {
        await dispatch(signOut())
        navigate('/login')
    }
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => true);
    };


    return (
        <>
            <AppBar position="fixed" className='appBar-Container'>
                <Toolbar disableGutters className='flex justify-content-between px-4'>
                    <div className='align-items-center flex'>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <img src={logo} alt="logo" style={{
                            height: '30px'
                        }}></img>
                    </div>

                    <div className='align-items-center flex'>
                        <Box sx={{ flexGrow: 0 }}>
                            <IconButton sx={{ p: 0 }}>
                                <Avatar alt="Remy Sharp" src={avatar} />
                            </IconButton>
                        </Box>
                        {
                            !userDetails.isAdmin && <Notifications></Notifications>
                        }
                        <Button variant="outlined" className="signOutButton" onClick={logOut}>Sign Out</Button>
                    </div>
                </Toolbar>
            </AppBar>
            {
                userDetails.isAdmin && <SideNav open={mobileOpen} navbarReset={() => {
                    setMobileOpen(false)
                }}></SideNav>
            }

        </>

    );
}
export default Navbar;
